module.exports = {"654027100":"特克斯镇","654027101":"乔拉克铁热克镇","654027102":"喀拉达拉镇","654027103":"齐勒乌泽克镇","654027104":"喀拉托海镇","654027200":"呼吉尔特蒙古民族乡","654027201":"阔克苏乡","654027203":"阔克铁热克柯尔克孜民族乡","654027404":"特克斯军马场","654027405":"科克苏林场","654027517":"兵团七十八团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654027.json
// module id = 2917
// module chunks = 0